/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col } from 'antd';

import { useModalControls } from '@hooks';
import { FILTER_OPTION, FILTER_OPTIONS } from '@api/media/constants';
import { Button } from '@atoms';
import { getTypeName } from '@utils/media';
import { MediaLibraryModal, Pagination } from '@molecules';

import MediaTiles from '../MediaTiles';
import UpsertMediaModal from '../UpsertMediaModal';

const getDefaultTitle = (type) => `Add ${getTypeName(type)}`;
const getDefaultUploadButtonText = (type) => `UPLOAD ${getTypeName(type).toUpperCase()}`;
const getDefaultSubtitle = (type) => {
  const typeName = getTypeName(type);
  return `Choose an existing ${typeName} or upload a new ${typeName} to appear on the page.`;
};

const SelectMedia = ({
  type,
  title = getDefaultTitle(type),
  uploadButtonText = getDefaultUploadButtonText(type),
  subtitle = getDefaultSubtitle(type),
  onSelect,
}) => {
  const modal = useModalControls();
  const mediaLibrary = MediaTiles.useMediaLibrary({
    perPage: 15,
    listQueryVariables: { type },
    useSearchParam: () => React.useState(),
  });

  return (
    <>
      <MediaLibraryModal.Heading style={{ alignItems: 'flex-start' }}>
        <MediaLibraryModal.Title
          subtitle={subtitle}
          extra={
            <Button type="customBlue" onClick={modal.show}>
              {uploadButtonText}
            </Button>
          }
        >
          {title}
        </MediaLibraryModal.Title>
      </MediaLibraryModal.Heading>
      <MediaTiles.Header
        search={{ onSearch: mediaLibrary.query.set, defaultValue: mediaLibrary.query.value }}
        tag={{ onChange: mediaLibrary.tag.set, defaultValue: mediaLibrary.tag.value }}
        filter={{
          options: FILTER_OPTIONS,
          defaultValue: type || mediaLibrary.filter.value || FILTER_OPTION.ALL.key,
          disabled: Boolean(type),
          onSelect: mediaLibrary.filter.set,
        }}
        sort={{ defaultValue: mediaLibrary.sort.value, onSelect: mediaLibrary.sort.set }}
      />
      <MediaTiles mediaLibrary={mediaLibrary} selectable={false} variant="small" onSelect={onSelect} />
      <Row justify="center" size="small" style={{ marginTop: 30 }}>
        <Col>
          <Pagination
            current={mediaLibrary.pagination.page}
            pageSize={mediaLibrary.pagination.perPage}
            total={mediaLibrary.pagination.total}
            onChange={mediaLibrary.pagination.handleChange}
          />
        </Col>
      </Row>
      <UpsertMediaModal {...modal} type={type} />
    </>
  );
};

export default SelectMedia;
